import React from 'react'
import { Link } from 'react-router-dom';

import searchIcon from '../../assets/searchIcon.svg';

import styled from 'styled-components'
import SearchResults from './SearchResults';

export default function NavbarDesktop({
  navbarRef,
  searchVisible,
  setSearchVisible,
  searchValue,
  setSearchValue,
  inputSearchRef,
  handleSearchBlur,
  handleSearchInputChange,
  handleClickSearchIcon,
  menuRef,
  searchResults,
  visiblePages
}) {
  return (
    <>
    <Wrapper ref={navbarRef}>
      <HEADER $searchVisible={searchVisible}>
        <Link className='link' to='/'>ХИМЕРЫ</Link>
      </HEADER>
      <SEARCH
        $searchVisible={searchVisible}
      >
        <SEARCH_INPUT
          ref={inputSearchRef}
          $searchVisible={searchVisible}
          type="text"
          value={searchValue}
          placeholder="Поиск"
          onBlur={handleSearchBlur}
          onChange={handleSearchInputChange}
        />
      </SEARCH>

      <MENU_OPTIONS
        ref={menuRef}
        $searchVisible={searchVisible}
      >
        {visiblePages.map((page, index) => (
          <li key={index}>
            <Link className='link' to={`/${page.title}`}>{page.display_title}</Link>
          </li>
        ))}
      </MENU_OPTIONS>
      <div className="icons">
        <img src={searchIcon} alt="Search Icon" onClick={handleClickSearchIcon} />
      </div>
    </Wrapper>
    <SearchResults
      navbarRef={navbarRef}
      searchResults={searchResults}
      searchVisible={searchVisible}
      setSearchVisible={setSearchVisible}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />
    </>
  )
}

const Wrapper = styled.div`
  min-height: 3.75rem;
  padding: 19px 22px 15px 24px;
  border-bottom: 1px solid #000;
  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // flex-wrap: wrap;

  & .icons {
    display: flex;
    gap: 1.5rem;
    order: 3;
  }
`;

const SEARCH = styled.div`
  display: ${props => props.$searchVisible ? 'flex' : 'none'};
  order: 1;
  align-items: center;
  justify-content: flex-start;
  width: 75%;
  height: 1.5rem;
`;

const SEARCH_INPUT = styled.input`
  border: none;
  border-bottom: 1px solid #000;
  outline: none;
  width: 100%;
  height: auto;
  margin-right: 4.8rem;

  font-family: var(--secondary-font);
  font-size: 1.25rem;
`;

const HEADER = styled.h1`
  margin-right: auto;
  
  display: block;

  font-size: 1.875rem;
  font-weight: 700;
  font-family: var(--primary-font);

  &:hover {
    cursor: hover;
  }

  & .link {
    text-decoration: none;
    color: black;
  }
`;

const MENU_OPTIONS = styled.ul`
  margin: 0;
  padding: 0 4.8rem 0 0;

  display: ${props => props.$searchVisible ? 'none' : 'flex'};
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 2rem;

  height: ${props => props.$searchVisible ? '0' : 'auto'};
  opacity: 1;
  transform: translateY(0);

  list-style: none;

  overflow: hidden;

  & li .link {
    font-size: 1.221rem;
    font-weight: 700;
    font-family: var(--primary-font);
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  & li .link:hover {
    text-decoration: underline;
  }
`;